import Tour from './Tour';

export default Tour;
